import React from 'react';

const TeamInfo = ({teamInfo}) => {
   
    return (
        <div className="team-info-left ">
            <h5 className="section-title">{teamInfo?.title[0]?.text}</h5>
            <h1 className="subtitle ">{teamInfo?.sub_title[0]?.text}</h1>
            <p className='body-text text-start'>{teamInfo?.description[0]?.text}</p>

        </div>
    );
};

export default TeamInfo;